import type { ReactNode } from "react";

interface SvgContainerProps {
    children: ReactNode;
    width: number;
    height: number;
    className?: string;
}
export function SvgContainer({ children, width, height, className = "" }: SvgContainerProps) {
    return (
        <div
            className={`overflow-hidden w-full h-full flex items-center justify-center ${className}`}
        >
            <svg
                viewBox={`0 0 ${width} ${height}`}
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width: "auto",
                    height: "auto",
                    aspectRatio: `${width} / ${height}`,
                }}
            >
                <defs>
                    <filter id="shadow" width="120" height="120">
                        <feDropShadow stdDeviation={4} dx={0} dy={4} floodOpacity={0.25} />
                    </filter>
                </defs>
                {children}
            </svg>
        </div>
    );
}
